import $ from "jquery";

if (document.querySelector(".slidecertCont")) {

    const sliderCertificaciones = document.querySelectorAll(".slidecertCont");

    sliderCertificaciones.forEach(certSlider => {
        $(certSlider).slick({
            dots: false,
            autoplay: true,
            //autoplaySpeed: 2000,
            autoplaySpeed: 0,        
            speed: 5000,      
            cssEase: 'linear',
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            centerMode: true,
            variableWidth: true,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 769,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },]

        });
    });
}